'use strict';

const VueX = require('vuex');
const Vue = require('vue');

const couponsModule = require('./modules/coupons');
const errorModule = require('./modules/error');
const orderSummaryModule = require('./modules/order-summary');
const deliveryModule = require('./modules/delivery/delivery');
const addressBookModule = require('./modules/address-book');
const detailsModule = require('./modules/details');
const paymentsModule = require('./modules/payments');
const analyticsModule = require('./modules/analytics');
const bonusItemsModule = require('./modules/bonus-items');
const privacyModule = require('./modules/privacy-consent');
const socialCommerceModule = require('./modules/social-commerce');
const eurobonusModule = require('./modules/eurobonus');

Vue.use(VueX);
const data = JSON.parse(document.getElementById('cart-data').dataset.json);
const checkoutGtmData = JSON.parse(document.getElementById('checkout-gtm-data').dataset.json);

module.exports = new VueX.Store({
    modules: {
        bonusItems: bonusItemsModule(data.bonusItemsData),
        delivery: deliveryModule(data.deliveryData),
        addressBook: addressBookModule(data.addressBookData),
        details: detailsModule(data.detailsData),
        coupons: couponsModule(data.couponData),
        orderSummary: orderSummaryModule(data.orderSummaryData),
        payments: paymentsModule(data.paymentData),
        error: errorModule(data.deliveryData.exclusionResults ? data.deliveryData.exclusionResults.errorMessage : ''),
        analytics: analyticsModule(checkoutGtmData),
        privacyConsent: privacyModule(data.privacyConsentData),
        socialCommerceData: socialCommerceModule(data.socialCommerceData),
        eurobonus: eurobonusModule(data.eurobonusData)
    },
    state: {},
    actions:{},
    mutations:{},
    strict: "development" !== 'production'
});
